import { ContextMenu } from "lib/@components/context-menu-bar"

export const ProjectContextMenu = ContextMenu("project")
